import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { YAHOO_TARGET } from '../../constants/yahoo';
import { SITE } from '../../constants/site';
import { isSiteIndexPage } from '../../utilities/site';
import {
  getFunlidayCookie,
  setFunlidayCookie
} from '../../utilities/funlidayCookie';

import './areaSwitcher.min.css';

const AREA_LIST = [
  {
    AREA: 'Taiwan',
    LANG: '繁中 (臺)',
    SITE: SITE.tw.site,
    HL: SITE.tw.defaultLang,
    PATH: SITE.tw.path,
    LANGUAGES: SITE.tw.languages
  },
  {
    AREA: 'Hong Kong',
    LANG: '繁中 (港)',
    SITE: SITE.hk.site,
    HL: SITE.hk.defaultLang,
    PATH: SITE.hk.path,
    LANGUAGES: SITE.hk.languages
  },
  {
    AREA: 'Japan',
    LANG: '日本語',
    SITE: SITE.jp.site,
    HL: SITE.jp.defaultLang,
    PATH: SITE.jp.path,
    LANGUAGES: SITE.jp.languages
  },
  {
    AREA: 'Global',
    LANG: 'ENG',
    SITE: SITE.en.site,
    HL: SITE.en.defaultLang,
    PATH: SITE.en.path,
    LANGUAGES: SITE.en.languages
  },
  {
    AREA: 'China',
    LANG: '简中',
    SITE: SITE.cn.site,
    HL: SITE.cn.defaultLang,
    PATH: SITE.cn.path,
    LANGUAGES: SITE.cn.languages
  },
  {
    AREA: 'South Korea',
    LANG: '한국어',
    SITE: SITE.kr.site,
    HL: SITE.kr.defaultLang,
    PATH: SITE.kr.path,
    LANGUAGES: SITE.kr.languages
  }
];

const AreaSwitcher = React.memo(({ onMenuClick }) => {
  const { target: siteTarget } = useSelector(state => state.init);

  const [showMenu, setShowMenu] = useState(false);
  const [currentArea, setCurrentArea] = useState('en');
  const ref = useRef(null);

  const onAreaTitleClick = () => {
    setShowMenu(preState => !preState);
  };

  const onAreaTitleKeyDown = ev => {
    if (ev.key === 'Enter' || ev.key === 'Space') {
      ev.preventDefault();
      onAreaTitleClick();
    }
  };

  const onAreaClick = (path, site, hl) => {
    if (onMenuClick) {
      onMenuClick();
    }

    setShowMenu(false);
    console.log('path', path, 'site', site, 'hl', hl);

    setFunlidayCookie('language', hl.replace(/-/g, '_'));
    setFunlidayCookie('region', site);

    console.log('set region', site);

    const { pathname } = document.location;
    const isMatchSiteIndexPage = isSiteIndexPage(pathname);

    if (isMatchSiteIndexPage) {
      const WEB_DOMAIN = process.env.REACT_APP_WEB_DOMAIN;
      // eslint-disable-next-line no-restricted-globals
      location.href = `${WEB_DOMAIN}${path}`;

      return;
    }
    // keep original url and reload page
    // eslint-disable-next-line no-restricted-globals
    location.replace(location.href);
  };

  const onAreaKeyDown = (path, site, hl, ev) => {
    if (ev.key === 'Enter' || ev.key === 'Space') {
      ev.preventDefault();
      onAreaClick(path, site, hl);
    }
    if (ev.key === 'ArrowUp' || ev.key === 'ArrowLeft') {
      ev.preventDefault();
      ev.target?.previousElementSibling?.focus();
    }
    if (ev.key === 'ArrowDown' || ev.key === 'ArrowRight') {
      ev.preventDefault();
      ev.target?.nextElementSibling?.focus();
    }
  };

  const clearMemberMenu = event => {
    const target = event.target;
    if (ref.current && target && !ref.current.contains(target)) {
      setShowMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', clearMemberMenu);

    const fldRegion = getFunlidayCookie('region');

    console.log('fldRegion', fldRegion);

    setCurrentArea(fldRegion);

    return () => {
      document.removeEventListener('click', clearMemberMenu);
    };
  }, []);

  const [currentData] = AREA_LIST.filter(item => item.SITE === currentArea);

  return siteTarget !== YAHOO_TARGET ? (
    <li
      onClick={onAreaTitleClick}
      onKeyDown={onAreaTitleKeyDown}
      ref={ref}
      style={{ cursor: 'pointer' }}
      className="area-siwtcher"
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={0}
    >
      <span className="area-text">
        {currentData.LANG}
        <span className="area-arrow" />
      </span>

      {showMenu ? (
        <ul className="area-list">
          {AREA_LIST.map(item => (
            <li
              key={item.SITE}
              onClick={() => onAreaClick(item.PATH, item.SITE, item.HL)}
              onKeyDown={ev => onAreaKeyDown(item.PATH, item.SITE, item.HL, ev)}
              className={item.SITE === currentArea ? 'current-area' : null}
              // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
              tabIndex={0}
            >
              <span>{item.LANG}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </li>
  ) : null;
});

AreaSwitcher.defaultProps = {
  onMenuClick: null
};

AreaSwitcher.propTypes = {
  onMenuClick: PropTypes.func
};

export default AreaSwitcher;
